import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon, ZapIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/electrical';
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(purchaseNotifications[0]);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setBuyer(purchaseNotifications[Math.floor(Math.random() * purchaseNotifications.length)]);
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const first = setTimeout(show, 3000);
    const interval = setInterval(show, 15000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-149" data-mp="f79si9vyb792">
      {visible && <motion.div initial={{
      opacity: 0,
      x: 40,
      scale: 0.96
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: 40,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed right-2 top-2 z-50 w-[228px] sm:w-[250px]" role="status" aria-live="polite" data-id="element-150" data-mp="b2se6q8d1m5o">
          <div className="relative overflow-hidden rounded-lg border-[3px] border-volt bg-white p-2 pr-6 shadow-2xl" data-id="element-151" data-mp="286sgzwuoomo8">
            <span className="absolute inset-x-0 top-0 h-1 bg-navy" aria-hidden="true" data-id="element-152" data-mp="1bh1bl2kutf3n" />
            <button type="button" onClick={() => setVisible(false)} aria-label="Close notification" className="absolute right-1 top-1.5 text-carbon/50 transition-colors duration-150 hover:text-navy" data-id="element-153" data-mp="1fhuz3uudwrw0">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-154" data-mp="rqzf3jw670zb" />
            </button>
            <div className="flex items-center gap-2" data-id="element-155" data-mp="wqbzlxzkjvyq">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-volt text-navy" data-id="element-156" data-mp="wp0yk5xid2bb">
                <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-157" data-mp="1v2xzvj3cphao" />
              </span>
              <div className="leading-tight" data-id="element-158" data-mp="1v13r135ctfmy">
                <p className="font-head text-[12px] font-extrabold text-navy" data-id="element-159" data-mp="28ul1zzjz5k1d">
                  {buyer.name}
                </p>
                <p className="text-[10px] font-semibold text-carbon/70" data-id="element-160" data-mp="24tj9e1kkc68d">
                  {buyer.location}
                </p>
                <p className="mt-0.5 text-[10px] font-bold text-navy" data-id="element-161" data-mp="1h4zydea4pfcl">
                  just purchased ELECTRICAL DIAGNOSTIC PRO™
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}